<script>
  export let id

  import { Input, Button } from "agnostic-svelte"
	
  import { navigate } from "svelte-routing"
  import { apikey, store } from "../store"
  import { PlanFromCMSPlan } from "../../cms/objects"
  import Common from "./Common.svelte"
  import Modal from "../../comps/Modal.svelte"
  

  $: counties = fetch(
    `https://marketplace.api.healthcare.gov/api/v1/counties/by/zip/${store.userd.zip}?apikey=${apikey}`
  ).then((v) => v.json())

  $: plan_promise = counties.then((counties) => {
    const c = counties.counties?.[0]
    if (!c) {
      console.error("No county found", counties)
      return
    }
    return fetch(
      `https://marketplace.api.healthcare.gov/api/v1/plans/${id}?apikey=${apikey}`,
      {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          household: {
            income: Number(store.userd.income),
            people: store.userd.people.map((p) => ({
              age: Number(p.age),
              gender: p.sex === "M" ? "Male" : "Female",
            })),
            has_married_couple: store.userd.people.some(
              (p) => p.name === "Spouse"
            ),
          },
          market: "Individual",
          place: {
            countyfips: c.fips,
            state: c.state,
            zipcode: c.zipcode,
          },
        }),
      }
    )
      .then((v) => v.json())
      .then(({ plan, ...d }) =>
        plan ? PlanFromCMSPlan(plan) : Promise.reject(d)
      )
  })
  
  $: {
    if (process.env.NODE_ENV === 'development') {
      plan_promise?.then(console.log)
    }
    
    }

  let show_enroll = false
</script>

<Common {plan_promise}>
  <Button on:click={() => (show_enroll = true)}>Enroll</Button>
</Common>

{#if show_enroll}
  <Modal on:close={() => (show_enroll = false)}>
    <h3 class="m8">
      Tell us your phone number so one of our agents can reach you
    </h3>

    <form class="dialog-form-demo">
      <Input
        isRounded
        label="Phone (required)"
        type="phone"
        id="phone"
        placeholder="333-333-3333"
        required
      />
      <div class="mbe16" />
      <Button
        type="submit"
        mode="primary"
        isRounded
        isBlock
        on:click={() => navigate("/thanks")}
      >
        Call me
      </Button>
      <Button
        type="submit"
        isRounded
        isBlock
        on:click={() => (show_enroll = false)}
      >
        Back to Plan
      </Button>
    </form>
  </Modal>
{/if}
